module.exports = __webpack_public_path__ + "img/x-circle-outline-gray.5707ee28.svg";